module.exports = __webpack_public_path__ + "img/img19.030372c8.png";